import React from "react";
import { Layout, MyTeam } from "../components";

const MyTeamPage = () => {
  return (
    <>
      <Layout>
        <MyTeam />
      </Layout>
    </>
  );
};

export default MyTeamPage;
